import { useMemo } from "react";

export function getStoredUser() {
    if (typeof localStorage === "undefined") return null;
    const raw = localStorage.getItem("user");
    if (!raw) return null;
    try {
        return JSON.parse(raw);
    } catch {
        return null;
    }
}

export function extractPermissionCodes(permisos) {
    if (!Array.isArray(permisos)) return [];
    return permisos
        .map((permiso) => {
            if (typeof permiso === "string") return permiso;
            if (permiso && typeof permiso.codigo === "string") return permiso.codigo;
            return null;
        })
        .filter(Boolean);
}

export function getPermissionState() {
    const user = getStoredUser();
    if (!user) return { user: null, permisos: [], codes: [], isSuperadmin: false };
    const permisos = Array.isArray(user.permisos) ? user.permisos : [];
    const codes = extractPermissionCodes(permisos);
    const isSuperadmin = user.rol_id === 1;
    return { user, permisos, codes, isSuperadmin };
}

export function hasPermission(code, codes, isSuperadmin = false) {
    if (!code || isSuperadmin) return true;
    const available = Array.isArray(codes) ? codes : getPermissionState().codes;
    return available.includes(code);
}

export function hasAnyPermission(required, codes, isSuperadmin = false) {
    const needed = Array.isArray(required) ? required.filter(Boolean) : [];
    if (!needed.length || isSuperadmin) return true;
    const available = Array.isArray(codes) ? codes : getPermissionState().codes;
    return needed.some((code) => available.includes(code));
}

export function hasAllPermissions(required, codes, isSuperadmin = false) {
    const needed = Array.isArray(required) ? required.filter(Boolean) : [];
    if (!needed.length || isSuperadmin) return true;
    const available = Array.isArray(codes) ? codes : getPermissionState().codes;
    return needed.every((code) => available.includes(code));
}

export function usePermissions() {
    return useMemo(() => {
        const state = getPermissionState();
        return {
            ...state,
            hasPermission: (code) => hasPermission(code, state.codes, state.isSuperadmin),
            hasAnyPermission: (list) => hasAnyPermission(list, state.codes, state.isSuperadmin),
            hasAllPermissions: (list) => hasAllPermissions(list, state.codes, state.isSuperadmin),
        };
    }, []);
}
